/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
  "use strict";

  import Utils = Common.Utils;

  export class PreventTemplateCacheService {
    public static $name: string = "preventTemplateCacheService";
    public static $inject: string[] = ["$rootScope"];
    private $rootScope: IFlexRootScope;

    constructor($rootScope: IFlexRootScope) {
      this.$rootScope = $rootScope;
    }

    public request = (config: ng.IRequestConfig): ng.IRequestConfig => {
      let commit: string = window.versionInfo ? window.versionInfo.commit : "";
      if (
        this.$rootScope &&
        this.$rootScope.versionInfo &&
        this.$rootScope.versionInfo.commit
      ) {
        commit = this.$rootScope.versionInfo.commit;
      }
      if (window.backendUrl.indexOf("localhost:5000") !== -1) {
        config.url = config.url.replace(
          /^(.*?)(\/api)/,
          "http://localhost:5000/api"
        );
      }
      if (
        Utils.startsWith(config.url, "views/") ||
        Utils.startsWith(config.url, "decorators/")
      ) {
        config.url = config.url + "?t=" + commit;
      }
      return config;
    };
  }
}
